"use strict";

class Menu {
  // pageBarHeight = $("[data-page-info-bar]").outerHeight();
  // logoBarHeight = $("[data-logo-bar]").outerHeight();

  /* --------------------------------------------------- INITIALIZATION --- */
  constructor() {
    const _this = this;

    $(window).scroll(function () {
      _this.toggleHeaderClass($(this));
      // _this.toggleHeaderClassMobile($(this));
      
    });

    $(document).on("keydown", function (e) {
      if (e.keyCode === 27) {
        _this.closeMegaMenu();
      }
    });

    this.initHandleEvent();
    this.adjustMenuSize();
    this.resizeMenu();
    this.menuShowMore();
  }

  /* ---------------------------------------------------- HANDLE EVENTS --- */
  initHandleEvent() {
    const _this = this;

    // Otwieranie mega menu
    $("[data-menu-hamburger]").on("click", function () {
      _this.showMegaMenu();

      let el = document.querySelector("[data-mega-menu].expanded");
      el.scrollIntoView(true);

      let activeEl = document.querySelector(
        "[data-dropdown-content].isExpanded"
      );
      activeEl.scrollIntoView({ behavior: "smooth" });
    });

    //Otwieranie wyszukiwarki
    $("[data-search-btn]").on("click", function () {

//  start  testy na dev
//      localStorage.setItem("cookieAccepted", "yes");
//      $(".searchPopup__searchArea").removeClass("hidden");
//end testy na dev
      $.ajax({
        method: "GET",
        //  start  testy na dev
//       url: 'http://dev01.araw.protnet.pl/~apawlus/front/proxy/wroclaw-pl-strona-glowna/get-html-parts?type=search_popup',
        //end testy na dev
        url: 'https://www.wroclaw.pl/beta2/proxy/wroclaw-pl-strona-glowna/get-html-parts?type=search_popup',
        beforeSend: function () {
          $(".ajaxSearchPopup").addClass("loading");
        },
      }).done((data, status) => {
        document.body.appendChild(document.createElement("script")).src =
          "https://cse.google.com/cse.js?cx=81a0fc2598a991da8";
        $(".ajaxSearchPopup").removeClass("loading");

        if (status === "success") {
          let ajaxNewsletterForm =
            document.getElementsByClassName("ajaxSearchPopup");
          ajaxNewsletterForm.item(0).insertAdjacentHTML("beforeend", data);

          _this.showSearchPopup();
          
        }
        trapFocus('#searchPopupWrapper');
        
        //Przeładowanie wyszukiwarki po kliku w paginacje
        $(document).on("click", ".gsc-cursor", function () {
          _this.showSearchPopup();
        });

        //Zamykanie wyszukiwarki
        $("[data-close-search-popup]").on("click", function () {
          _this.hideSearchPopup();
          $("#searchPopup").remove();
        });

        //Zamykanie wyszukiwarki za pomocą klawiatury
        $("[data-close-search-popup]").keyup(function (e) {
          if (e.keyCode == 13) {
            _this.hideSearchPopup();
            $("#searchPopup").remove();
          }
        });
      });
    });

    // Zamykanie mega menu
    $("[data-close-menu]").on("click", function () {
      _this.closeMegaMenu();
    });

    // akceptacja cookies a widok działajacej wyszukiwarki
    $(document).on("click", ".cky-btn-accept", function () {
      _this.hideCookiesInfo();
    });

    // Zmiana zawartości taba - desktop
    if ($(window).width() > 991) {
      $("[data-menu-header]").on("click", function () {
        _this.changeTabContent($(this));
      });

      // Zmiana zawartości taba za pomoca klawiatury - desktop
      $("[data-menu-header]").keyup(function (e) {
        if (e.keyCode == 13) {
          _this.changeTabContent($(this));
        }
      });
    }
    
    // Zmiana zawartości taba - tablet/mobile
    if ($(window).width() < 992) {
      $("[data-menu-header]").on("click", function () {
        _this.dropdownContent($(this));

        // przewijanie aktywnego elementu do gornej krawędzi ekranu
        // setTimeout(() => {
        //   let activeEl = document.querySelector("[data-dropdown-content].isExpanded");
        //   activeEl.scrollIntoView({behavior: "smooth"});
        //   console.log("test test")
        // }, 30);
      });
    }

    $("[data-lang-list]").each(function () {
      $(this).change(function () {
        if ($(this).val() == 'pl') {
          window.location.href = "https://www.wroclaw.pl";
          return;
        }
        window.location.href = "https://www.wroclaw.pl/" + $(this).val();
        $(this).val("pl");
      });
    });

    $("[data-megamenu-main-links]").click(function (e) {
      const clickedElement = e.target;
      const isItMainMenuLinkClicked = $(clickedElement).closest('.boxHeader ').length > 0
      if ($(window).width() > 991 && isItMainMenuLinkClicked) {
        const tilesListAlreadyInView = $(`.dropdownContent.active .boxListSection`).length > 0;
        if( tilesListAlreadyInView) return false
        const clickedMainLink = $(this).find('.dropdownContent.active');
        if( clickedMainLink.hasClass('ajaxLoaded')) return false
        const clickedMainLinkID = clickedMainLink.attr('data-id-this');
        const dynamicMenuTiles =  $(`[data-id-this="${clickedMainLinkID}"] [data-dynamic-menu-tiles]`);
        const dynamicMenuBottom =  $(`[data-id-this="${clickedMainLinkID}"] [data-dynamic-menu-bottom]`);
        const menuContent = $(this).find('.menuContent');
        $.ajax({
          type:   'GET',
          url:    `https://www.wroclaw.pl/beta2/proxy/wroclaw-pl-strona-glowna/get-mega-menu?item=${clickedMainLinkID}`,
          // url:    `https://front.a.pawlus.dev.wroclaw.pl/proxy/wroclaw-pl-strona-glowna/get-mega-menu?item=${clickedMainLinkID}`,
          async:   true,
          //
          beforeSend: function() {
            menuContent.addClass('loading');
          },
        })
        .done((data) => {
          if(data === '') {
            return false
          }
          const lists = data.split('<hr>')
          dynamicMenuTiles.prepend(lists[0]);
          dynamicMenuBottom.prepend(lists[1]);
          menuContent.removeClass('loading');
          clickedMainLink.addClass('ajaxLoaded');
        });
      }
    });
  }


  /* ---------------------------------------------------- DODATKOWE FUNKCJE --- */

  // Dodawanie i usuwanie klasy dla header'a - desktop
  toggleHeaderClass($window) {
    if (
      $window.scrollTop() >=
      $("[data-page-info-bar]").outerHeight() +
        $("[data-logo-bar]").outerHeight()
    ) {
      $("[data-main-header]").addClass("sticky");
    } else {
      $("[data-main-header]").removeClass("sticky");
    }
  }

  // Dodawanie i usuwanie klasy dla header'a - mobile // fix - dodanie sticky na stale zeby pasek menu
  // nie znikał na poczatku z widoku i zeby reklama gorna byla prawidłowo w układzie strony
  // toggleHeaderClassMobile($window) {
  //   if ($(window).width() < 992) {
  //     if ($window.scrollTop() >= $("[data-page-info-bar]").outerHeight()) {
  //       $("[data-page-info-bar]").addClass("sticky");
  //     } else {
  //       $("[data-page-info-bar]").removeClass("sticky");
  //     }
  //   }
  // }

  // Pokaż mega menu
  showMegaMenu() {
    $("[data-mega-menu]").addClass("expanded");
    $("body").removeClass("moveWidget");
    $("body").addClass("hideWidget");
    $('[data-menu-hamburger]').attr('aria-expanded', 'true');

    $('#megaMenuBox').attr('tabindex', 0);
    trapFocus('#megaMenuBox');
  }

  // Ukryj mega menu
  closeMegaMenu() {
    $("[data-mega-menu]").removeClass("expanded");
    $("body").addClass("moveWidget");
    $("body").removeClass("hideWidget");
    $('[data-menu-hamburger]').attr('aria-expanded', 'false');
    $('#megaMenuBox').removeAttr('tabindex');
  }

  //Pokaż popup wyszukiwarki
  showSearchPopup() {
    if ($("[data-search-popup]").hasClass("expanded")) {
      window.scroll({
        top: 0,
        left: 0,
      });
    } else {
      let scrollRestore = $(window).scrollTop();
      $("[data-search-popup]").addClass("expanded");
      $("[data-search-popup]").attr("data-scroll", scrollRestore);
      
      window.scroll({
        top: 0,
        left: 0,
      });

      $("html").addClass("no-scrollable");
      $("[data-mega-menu]").addClass("no-scrollable");
      // $(".gsc-input").focus();
    }
    const isCookieAccepted = this.checkIfCookiesAccepted();

    if(isCookieAccepted) {
      this.hideCookiesInfo();
      this.showSearchArea();
    }
  }

  checkIfCookiesAccepted() {
    const cookiesAccepted = document.cookie.includes("cky-consent=yes");
    const localCookieConsent = localStorage.getItem("cookieAccepted");
    if (cookiesAccepted || localCookieConsent === "yes") {
      return true;
    } else {
      return false;
    }
  }

  showSearchArea() {
    $(".searchPopup__searchArea").removeClass("hidden"); //visibility????
    $(".gsc-input").focus();
  }

  hideCookiesInfo() {
    $(".searchPopup__infoCookies").addClass("hidden");
  }
  
  hideSearchPopup() {
    $("[data-search-popup]").removeClass("expanded");
    $("html").removeClass("no-scrollable");
    $("[data-mega-menu]").removeClass("no-scrollable");
    let scrollRestore = $("[data-search-popup]").attr("data-scroll");
    window.scroll({
      top: scrollRestore,
      left: 0,
    });
  }

  // Zmiana zawartości taba
  changeTabContent($obj) {
    $("[data-dropdown-content]").removeClass("active");
    $("[data-menu-header]").attr('aria-expanded', 'false');
    $obj.parent().addClass("active");
    $obj.attr('aria-expanded', 'true');
  }

  // Zwijanie i rozwijanie (tablet, mobile)
  dropdownContent($obj) {
    if ($obj.parent().hasClass("isExpanded")) {
      $obj.parent().find("[data-more-content]").slideUp();

      setTimeout(function () {
        $obj.parent().removeClass("isExpanded");
      }, 300);
    } else {
      $obj.parent().addClass("isExpanded");
      $("[data-more-wrapper]")
        .removeClass("isExpanded")
        .find("[data-more-content]")
        .slideUp();
      $obj
        .parent()
        .addClass("isExpanded")
        .find("[data-more-content]")
        .slideDown();
    }
  }

  //menu size methods below
  adjustMenuSize(object = this) {
    if ($(window).width() > 991) {
      //below variables for calculating menu free space
      let mainHeader = document.querySelector(".mainHeader__content");
      let mainHeaderWidth = mainHeader.offsetWidth;
      let navList = document.querySelector(".mainNav");
      let navListWidth = navList.offsetWidth;
      let tools = document.querySelector(".mainHeader__tools");
      let toolsWidth = tools.offsetWidth;
      let stickyLogo = document.querySelector(".stickyLogo");
      let stickyLogoWidth = stickyLogo.offsetWidth;
      let menuSpaceForTools =
        mainHeaderWidth - navListWidth - toolsWidth - stickyLogoWidth;
      // console.log(menuSpaceForTools, 'menuSpaceForTools')

      
      let littleSpaceInMenu = 30;
      if ($(window).width() < 1400) {
        littleSpaceInMenu = 75;
      }

      //special styles for proxy rozmawia menu
      if ($("body").attr("data-main") == "rozmawia2") {
        $(".mainNav").addClass("center");
      } else {
        $(".mainNav").removeClass("center");
      }
      //global styles for menu
      // if (menuSpaceForTools < 23) {
      if (menuSpaceForTools < littleSpaceInMenu) {
        // console.log('moveLinks')
        object.moveLinksToMore();
        // } else if (menuSpaceForTools > 238 &&  !$('.moreOptions').hasClass('hidden')) {
      } else if (
        menuSpaceForTools > 256 &&
        !$(".moreOptions").hasClass("hidden")
      ) {
        // console.log('restoreLinks')
        object.removeLinksFromMore();
      }
    }
  }
  
  resizeMenu() {
    let startWindowWith = window.innerWidth;
    let _this = this;
    let waitForEnd = false;
    window.addEventListener("resize", function () {
      if ($(window).width() > 991) {
        let afterResizeWindowWidth = window.innerWidth;
        let widthDifference = startWindowWith - afterResizeWindowWidth;
        if (
          (waitForEnd == false && widthDifference > 5) ||
          widthDifference < -10
        ) {
          waitForEnd = true;
          _this.adjustMenuSize();
          waitForEnd = false;
          startWindowWith = afterResizeWindowWidth;
        }
      }
    });
  }

  moveLinksToMore() {
    let lastVisibleLnk = $(".moveToMore").last();
    lastVisibleLnk.removeClass("moveToMore");
    lastVisibleLnk.addClass("lnkInMore");
    lastVisibleLnk.remove();
    $(".moreOptions__menu").prepend(lastVisibleLnk);
    this.adjustMenuSize();
    this.hideOrShowMoreMenuLnk();
  }

  removeLinksFromMore() {
    let linkToBeVisible = $(".lnkInMore").first();
    if (linkToBeVisible.length == 0) return false;
    linkToBeVisible.removeClass("lnkInMore");
    linkToBeVisible.addClass("moveToMore");
    linkToBeVisible.remove();
    linkToBeVisible.insertBefore(".moreOptions");
    this.adjustMenuSize();
    this.hideOrShowMoreMenuLnk();
  }

  hideOrShowMoreMenuLnk() {
    let hasMoreMenuChildren = $(".moreOptions__menu").children().length;
    if (hasMoreMenuChildren > 0) {
      $(".moreOptions").removeClass("hidden");
    } else {
      $(".moreOptions").addClass("hidden");
    }
  }

  menuShowMore() {
    this.hideOrShowMoreMenuLnk();

    if ($(window).width() > 992) {
      $('.mainHeader .moreOptions').on('keydown mouseenter mouseleave', function(event) {
        if (event.keyCode === 13 || event.type === 'mouseenter') {
          // Toggle the aria-expanded attribute
          var isExpanded = $(this).find('.moreOptions__lnk').attr('aria-expanded') === 'true';
          $(this).find('.moreOptions__lnk').attr('aria-expanded', !isExpanded);
      
          // Toggle the hover class and slide the menu
          var menu = $(this).find('.moreOptions__menu');
          $(this).addClass('hover');
          $('.mainHeader .moreOptions.hover')
          .not(this)
          .removeClass('hover')
          .find('.moreOptions__menu')
          .stop().slideUp();
          menu.stop()
          .slideDown();
        }
      
        if (event.keyCode === 27 || event.type === 'mouseleave') {
          // If the escape key is pressed or mouse leaves, collapse the menu
          $(this).find('.moreOptions__lnk').attr('aria-expanded', 'false');
          $(this).removeClass('hover').find('.moreOptions__menu').stop().slideUp();
        }
      });
    } else {
      //po co else skoro mainNav ukryte na tabletmobile??? do SPR
      $(".mainHeader .moreOptions").click(function () {
        $(this)
          .toggleClass("hover")
          .children(".moreOptions__menu")
          .stop(true, true)
          .slideToggle();
      });
    }

  }
}